import React from 'react';
import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import {changePosition} from '../../actionCreators';

import Pin from './Pin';

const Message = gettext('The selected location is not contained in the current region.');
const Label = gettext('Map');

const Map = ({position, src, onClick}) => (
    <div id="location-map-image">
        <div className="location-map-wrapper">
            {position === null && <p>{Message}</p>}
            <img className="map" src={src} alt={Label} onClick={onClick} />
            {position && <Pin {...position} />}
        </div>
    </div>
);

const mapStateToProps = ({mapURL, position}) => ({
    src: mapURL,
    position,
});

const mapDispatchToProps = dispatch => ({
    onClick: ({target, clientX, clientY}) => {
        const {width, height} = target;
        const {pageXOffset, pageYOffset} = window;
        const {top, left} = target.getBoundingClientRect();
        const y = clientY - (pageYOffset + top) + pageYOffset;
        const x = clientX - (pageXOffset + left) + pageXOffset;

        dispatch(changePosition(x, y, width, height));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Map);
